import React from 'react';

interface Props {
  cx?: number;
  cy?: number;
  stroke?: string;
  fill?: string;
}

function ActiveDot(props: Props) {
  const { cx, cy } = props;
  if (!cx || !cy) return null;
  return (
    <circle
      cx={cx}
      cy={cy}
      r={5}
      stroke="hsl(var(--azure-400))"
      strokeWidth={2}
      fill="hsl(var(--neutral-900))"
    />
  );
}

export default ActiveDot;
